import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, inject, input, Input, numberAttribute, OnDestroy, OnInit, Renderer2, signal, ViewChild } from '@angular/core';
import { RdGameService } from '../../services/games/rd-game';
import * as _ from "lodash";
import { MatCheckboxModule } from '@angular/material/checkbox';
import {MatRadioChange, MatRadioModule} from '@angular/material/radio';
import { FormsModule } from '@angular/forms';
import { AllStatus } from '../../../core/services/status/all-status';
import { ConfigurationService } from '../../../core/services/configs/configuration';
import { RaitingSystem } from '../../services/ratings/raiting-system';
import { ITrainingAnswer, TrainingMode } from '../../services/trainings/training-mode';
import { Subscription, take } from 'rxjs';
import { DifficultyLevel } from '../../services/levels/difficulty-level';
import { TranslatePipe } from '@ngx-translate/core';
import { CardHictoryPlayer } from '../../services/history/card-hictory-player';
import { TeamEvent } from '../../services/teams/team-event';
import { QueryAi } from '../../services/ai/query-ai';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AiWindow } from '../dialogs/ai-window/ai-window';
import { ProgressPlayerService } from '../../../features/progress-player/progress-player.service';
import { LanguageService } from '../../../core/services/language/language.service';
import { Downtime } from '../../../core/services/times/downtime';
import { NotificationService } from '../../../core/services/Notification/notification';
import { MatTooltip, MatTooltipModule } from '@angular/material/tooltip';
import { WorkCardService } from '../../services/work-card';
import { CardCounter } from '../card-counter/card-counter';
import { ICard, ICardResultState, ICardUserVariant, ICardVariant } from '../../model/i-card';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-card-info-coop',
  imports: [MatCheckboxModule, MatRadioModule, FormsModule, TranslatePipe,MatTooltipModule, CardCounter],
  templateUrl: './card-info-coop.html',
  styleUrl: './card-info-coop.scss',
   changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardInfoCoop implements OnInit, OnDestroy{
@Input() player: any;
  @Input({transform: numberAttribute}) turning: number;
  playersLeng = input<any>();
  players = input<any>();
  userResponse = input<any>();
  previousPlayerScore = input<number | null>(null);
  previousPlayerResultState = input<ICardResultState | null>(null);

  rdUse = inject(RdGameService);
  progressService = inject(ProgressPlayerService);
  levelSer = inject(DifficultyLevel);
  language = inject(LanguageService)
  subTrainingMode: Subscription;
  public allStatus$ = inject(AllStatus);
  configuration = inject(ConfigurationService);
  raiting = inject(RaitingSystem);
  trainingModeSevvice = inject(TrainingMode);
  cardHictory = inject(CardHictoryPlayer);
  teamEvent = inject(TeamEvent);
  readonly dialog = inject(MatDialog);
  private readonly destroyRef = inject(DestroyRef);
  ai = inject(QueryAi);
  downtime = inject(Downtime);
  cardInfo = inject(WorkCardService);
   

  subCart: Subscription;
  subOtherCards: Subscription;
  showCard: any = {};
  listCards: any = [];
  private listTxt: any = [];
  lodash = _;
  trainingMode: number = 0;
  
  indexCards:number = 0;
  
  showGroupButton: boolean = true;
  isActiveUser: boolean = false;
  isOtherCards: boolean = false;
  playerResultState: ICardResultState | null = null;

  get isEmptyPlayerScore(): boolean {
    return this.playerResultState === 'missed-correct-answer';
  }

  get isNonPositivePlayerScore(): boolean {
    return this.playerResultState === 'non-positive-score';
  }

  get isPreviousPlayerResultError(): boolean {
    const resultState = this.previousPlayerResultState();
    const score = this.previousPlayerScore();
    if(score !== null && score < 0){
      return true;
    }

    if(resultState === 'no-correct-answer-available'){
      return false;
    }

    return resultState === 'missed-correct-answer' ||
      resultState === 'non-positive-score';
  }

  isCollapseExpand = signal<boolean>(true);
  list: ITrainingAnswer[] = [];
  selectVariant: number;
  myResult: number|null = null;
  notification = inject(NotificationService);

  private tooltipElement: HTMLElement | null = null;
  private renderer = inject(Renderer2);
  
  private listPrefix: any = [];
  private currentSharedCard: any = null;
  private currentTurningPlayerId: number | string | null = null;
  private currentTurnId: number | null = null;
 
  @ViewChild('tooltip') tooltip: MatTooltip;
  tooltipMessage:string = '';
  isShowExplanation: boolean = false;

  constructor( private ref: ChangeDetectorRef){
    this.listTxt["ru"] = ["Вы обрабатываете "," из "," карточек"," карточки"];
    this.listTxt["uk"] = ["Ви обробляєте "," з "," карток"," карток"];
    this.listTxt["en"] = ["Working on "," out of "," cards"," cards"];
  }

  onMouseOver(event: MouseEvent){
    const targetElement: HTMLElement = event.target as HTMLElement;
    if(targetElement.tagName === 'EM'){
      this.tooltipElement = this.renderer.createElement('span');
      this.tooltipMessage = targetElement.outerText;
      // @ts-ignore
      this.tooltipElement.innerText = `${this.listPrefix[this.language.appLanguage as string][0]}"${targetElement.innerText}"${this.listPrefix[this.language.appLanguage as string][1]}`;
      this.tooltipElement?.classList.add('another-tooltip');
      targetElement.appendChild(this.tooltipElement as HTMLElement);

      this.ref.detectChanges();
    }
    
  }

  onMouseOut(event: MouseEvent){
    const targetElement: HTMLElement = event.target as HTMLElement;
    if(targetElement.tagName === 'EM'){
      targetElement.removeChild(this.tooltipElement as HTMLElement);
      this.tooltipElement = null;
      this.tooltipMessage = '';
      this.ref.detectChanges();
    }
  }


  clearStaleCardState(clearExplanation = true): void {
    this.currentSharedCard = null;
    this.showCard = {};
    this.list = [];
    this.isActiveUser = false;
    this.showGroupButton = false;
    this.isShowExplanation = false;
    this.resetPlayerResult();
    this.tooltipMessage = '';
    if(clearExplanation){
      this.allStatus$.clearExplanationTxt();
    }
    this.allStatus$.clearNowCard();
    this.allStatus$.setViewBlockDice(true);
    this.allStatus$.isNewListVariant = true;
    this.indexCards = 0;
    this.isOtherCards = false;
  }

  ngOnInit(){
    this.isShowExplanation = false;
    this.listPrefix["ru"] = ["Узнать значения слова "," у чата GPT"];
    this.listPrefix["uk"] = ["Дізнатися значення слова "," у чату GPT"];
    this.listPrefix["en"] = ["Find out the meaning of the word "," at the GPT chat"];
    this.list = [];
    this.allStatus$.txtCardInfo = '';
    let isAddCard:boolean = true;
    this.cardHictory.clearHistory();
   
    this.subOtherCards = this.rdUse.value$.subscribe((game: any) =>{
      const queueMatchesTurn = game?.other_cards_turn_id == null ||
        Number(game.other_cards_turn_id) === Number(game?.turn_id ?? 0);
      this.listCards = queueMatchesTurn && Array.isArray(game?.other_cards)
        ? game.other_cards
        : [];
      this.ref.markForCheck();
    });

    this.subCart = this.rdUse.value$.subscribe((game: any)=>{
      this.currentTurningPlayerId = game?.turning_player_id ?? this.turning;
      this.currentTurnId = Number(game?.turn_id ?? 0);
      const cards = game?.card_now;

      if(cards){
        this.tooltipMessage = '';
        const staleTurnCard =
          (cards.turn_id == null && this.currentTurnId > 0) ||
          (cards.turn_id != null && Number(cards.turn_id) !== this.currentTurnId) ||
          (cards.owner_player_id != null &&
            String(cards.owner_player_id) !== String(this.currentTurningPlayerId));
        if(staleTurnCard){
          if(!_.isEqual(this.currentSharedCard, cards) || !_.isEmpty(this.showCard)){
            this.clearStaleCardState(false);
            this.currentSharedCard = structuredClone(cards);
          }
          this.ref.markForCheck();
          return;
        }

        if(!_.isEqual(this.currentSharedCard, cards)){
          this.currentSharedCard = structuredClone(cards);
          this.resetPlayerResult();
          isAddCard = true;
          this.isActiveUser = false;
          if(this.isCardOwner(cards)){
            if(this.isOtherCards){
              this.allStatus$.setViewBlockDice(false);
              this.showCard = cards;
              this.allStatus$.isNewListVariant = true;
              if(this.showCard?.data?.variants){
                this.getList(this.showCard.data.variants);
              }
              this.isActiveUser = true;
              this.showGroupButton = true;
              this.countCards();
            }else{
              const position = (this.player.rq_id > 100) ? this.player.rq_id - 100 : this.player.rq_id;
              if(position === cards.type_id){
                this.allStatus$.setViewBlockDice(false);
                this.isCollapseExpand.set(true);
                isAddCard = this.workingWithCard(cards, isAddCard);
              }
            }
          }else{
            isAddCard = this.workingWithCard(cards, isAddCard);
            const isCurrentPlayerTurn = String(this.currentTurningPlayerId) ===
              String(this.player.player_id);
            const cardBelongsToAnotherPlayer = cards?.owner_player_id != null &&
              String(cards.owner_player_id) !== String(this.player.player_id);
            this.allStatus$.setViewBlockDice(isCurrentPlayerTurn && cardBelongsToAnotherPlayer);
          }
        }else{
          this.isActiveUser = this.isOtherCards
            ? this.isCardOwner(this.showCard)
            : this.isCardOwner(cards) && this.showCard?.card_id === cards.card_id;
        }
      }else{
        if(this.currentSharedCard){
          this.clearStaleCardState(false);
        }
        this.currentSharedCard = null;
        this.allStatus$.isNewListVariant = true;
        this.allStatus$.setViewBlockDice(true);
        this.showCard = {};
        this.isActiveUser = false;
        this.resetPlayerResult();
        this.showGroupButton = false;
        isAddCard = true;
        this.allStatus$.maxPointresultCard = 0;
      }
      this.ref.markForCheck();
    });

    this.subTrainingMode = this.allStatus$.trainingMode$.subscribe((value: number) =>{
      this.trainingMode = value; 
    });
  }

  playersName(): string{
   let name = '';
   
    this.players().forEach((player: any) => {
      if(this.turning === player.player_id){
        name = player.name;
      }
    });
    return name;
  }

  workingWithCard(cards: any, isAddCard: boolean){
    if(!this.isOtherCards){
      if(isAddCard){
        this.cardHictory.addCardHistory({name: cards.name, level: cards.level, card_id : cards.card_id, type_id: cards.type_id});
        isAddCard = false;
      }
      this.showCard = cards;
      if(this.showCard?.data?.variants){
        this.getList(this.showCard?.data.variants);
      }
      if(this.isCardOwner(cards)){
        this.isActiveUser = true;
        if(!this.allStatus$.isPassBoll){
          this.showGroupButton = true;
          this.countCards();
        }
      }
      if(!this.isCardOwner(cards) && this.playersLeng() > 1){
        this.isActiveUser = false;
        this.allStatus$.isPassBoll = false;
        this.allStatus$.isRollDice = true;
        this.allStatus$.isNewListVariant = true;
        this.allStatus$.txtCardInfo = '';
      }
    }
    return isAddCard;
  }

  ngOnDestroy(): void {
    this.allStatus$.isNewListVariant = true;
    if(this.subCart){
      this.subCart.unsubscribe();
    }
    if(this.subTrainingMode){
      this.subTrainingMode.unsubscribe();
    }
    if(this.subOtherCards){
      this.subOtherCards.unsubscribe();
    }
    
    this.progressService.clearAll();
  }

  countCards(){
    const allCard = 1 + this.listCards.length;
    const val = 1 + this.indexCards;
    const txt = (this.listCards.length) ? `${this.listTxt[this.language.appLanguage as string][0]}${val}${this.listTxt[this.language.appLanguage as string][1]}${allCard}${this.listTxt[this.language.appLanguage as string][2]}`: `${this.listTxt[this.language.appLanguage as string][0]}${val}${this.listTxt[this.language.appLanguage as string][1]}${allCard}${this.listTxt[this.language.appLanguage as string][3]}`;
    this.allStatus$.txtCardInfo = txt;
  }

  fnRunInitOtherCards(){
    if(!this.canAct()){
      return;
    }

    if(this.listCards.length > this.indexCards){
      let cards = this.listCards[this.indexCards];
      const turnId = this.currentTurnId ?? 0;
      this.cardInfo.getCard(cards.card_id).pipe(
        take(1)
      ).subscribe((res: any)=>{
          const card = {
            ...res.card,
            owner_player_id: this.player.player_id,
            turn_id: turnId,
          };
          this.allStatus$.isNewListVariant = true;
          void this.rdUse.saveCard(card, this.player.player_id, turnId).then((committed) =>{
            if(!committed ||
              !this.isOtherCards ||
              Number(this.currentTurnId ?? 0) !== turnId ||
              String(this.currentTurningPlayerId ?? this.turning) !== String(this.player.player_id)){
              return;
            }
            this.cardHictory.addCardHistory({
              name: card.name,
              level: card.level,
              card_id: card.card_id,
              type_id: card.type_id,
            });
            this.indexCards = this.indexCards + 1;
            this.countCards();
            this.ref.markForCheck();
          }).catch((error: unknown) =>{
            console.error(`Failed to publish additional card ${cards.card_id}`, error);
          });
      }, (error: unknown) =>{
        console.error(`Failed to load additional card ${cards.card_id}`, error);
      });
    }else{
      this.isOtherCards = false;
      this.showGroupButton = false;
      this.allStatus$.isPassBoll = true;
      this.indexCards = 0;
      this.ref.markForCheck();
    }
    
  }

  private getList(variants: ICardVariant[]): void {
    if(this.allStatus$.isNewListVariant){
      this.resetPlayerResult();
      if(this.turning === this.player.player_id){
        if(this.showCard?.level){
          this.levelSer.isNewLevel(this.showCard?.level, this.showCard?.type_id, this.player.player_id);
        }
      }
      this.list = [];
      this.allStatus$.maxPointresultCard = 0;
      variants.forEach((item: ICardVariant, index: number)=>{
        if(this.configuration.configuration.config.show_points){
          this.list.push({...item, variant_name: `${item.variant_name}`,variant: false ,index, });
        }else{
          this.list.push({...item,variant: false ,index});
        }
        if(item.v_points > 0){
          this.allStatus$.maxPointresultCard = this.allStatus$.maxPointresultCard + item.v_points;
        }
      });
     // this.allStatus$.isNewListVariant = false;
      if(this.playersLeng() === 1){
        this.isCollapseExpand.set(true);
      }
      
    }
    
  }

  update(variant: boolean, index?: number): void {
    if(!this.canAct()){
      return;
    }

    this.list.forEach((item: ITrainingAnswer)=>{
      if(item.index === index){
        item.variant = variant;
      }
    })
  }

  onRadioGroupChange(event: MatRadioChange) {
    if(!this.canAct()){
      return;
    }

    this.list.forEach((item: ITrainingAnswer)=>{
        item.variant = false;
      if(typeof event.value === 'number' && item.index === event.value){
        item.variant = true;
      }
    });
    }

  canAct(): boolean {
    return this.isActiveUser &&
      this.isCardOwner(this.showCard) &&
      !_.isEmpty(this.showCard) &&
      !this.allStatus$.isPassBoll &&
      !this.isShowExplanation;
  }

  private isCardOwner(card: any): boolean {
    const turningPlayerId = this.currentTurningPlayerId ?? this.turning;
    if(String(turningPlayerId) !== String(this.player?.player_id)){
      return false;
    }

    return card?.owner_player_id == null ||
      String(card.owner_player_id) === String(this.player.player_id);
  }

  private resetPlayerResult(): void {
    this.playerResultState = null;
    this.myResult = null;
  }

  private determinePlayerResultState(
    userList: readonly ICardUserVariant[],
    points: number,
  ): ICardResultState {
    const hasSelectedAnswer = userList.some((item) => item.variant);
    const hasCorrectAnswer = userList.some((item) => item.v_points > 0);

    if(!hasSelectedAnswer){
      return hasCorrectAnswer
        ? 'missed-correct-answer'
        : 'no-correct-answer-available';
    }

    return points <= 0 ? 'non-positive-score' : 'positive-score';
  }

  private calculateResultPercentage(points: number, maxPoints: number): number {
    if(maxPoints <= 0){
      return 0;
    }

    return Number(((points / maxPoints) * 100).toFixed(2));
  }

  asseccCard(){    
    if(!this.canAct()){
      return;
    }

    if(this.showCard?.data?.variants){   
      this.allStatus$.isNewListVariant = false;       
      let otherCard: ICard = structuredClone(this.showCard);
      
      otherCard.data.userList = this.list;      

      if(otherCard.level){
        this.levelSer.initWork(otherCard);
      }

      let result = this.raiting.successesInGame(otherCard);

      this.playerResultState = this.determinePlayerResultState(
        otherCard.data.userList ?? [],
        result.points,
      );
      this.myResult = this.calculateResultPercentage(result.points, result.maxPoints);

      this.rdUse.submitPlayerResponse(this.list, this.myResult, this.playerResultState);

      if(!this.configuration.configuration?.config?.is_demo){
        if(this.isCardPlayer(otherCard.type_id)){
          this.progressService.fnSetRating(otherCard.type_id, result.points, result.maxPoints, otherCard.level);
        }
      }

      if(this.trainingMode){
        if( (this.playersLeng() as number) > 1 ){
          this.showGroupButton = false;
        }else{
          this.isShowExplanation = true;
        }
        
        this.list = this.trainingModeSevvice.checkingCorrectnessAnswer(result.maxPoints, this.showCard?.data?.variants_type, this.list);
        if((this.playersLeng() as number) > 1 && otherCard.data?.explanation){
          this.allStatus$.setExplanationData({cardId: otherCard.card_id,count: this.cardHictory.countReverse(otherCard.type_id, otherCard.level ), level: otherCard.level}); // this.cardHictory.countCardLevel(otherCard.type_id, otherCard.level )
          this.allStatus$.setExplanationTxt(otherCard.data.explanation);
        }
      }
      this.allStatus$.setNowCard(otherCard);

      //TODO other_true && team event
      if( (this.playersLeng() as number) > 1 ){
        this.teamEvent.fn(this.showCard, this.player.player_id, result.points, this.playersLeng());
      }
    }
    this.downtime.refreshTimer();
    
    if(this.listCards.length > this.indexCards){
      this.isOtherCards = true;
      this.allStatus$.isPassBoll = false;
      this.fnRunInitOtherCards();
      this.isActiveUser = false;
      this.showGroupButton = false;
    }else if( (this.playersLeng() as number) > 1 ){
      this.isOtherCards = false;
      this.showGroupButton = false;
      this.allStatus$.isPassBoll = true;
    }else{
      this.isShowExplanation = true;
    }
    //this.allStatus$.maxPointresultCard = 0;

  }

  fnIsShowExplanation(){
    this.allStatus$.isPassBoll = true;
    this.showGroupButton = false;
    this.isShowExplanation = false;
  }

  clearExplanation(){
    this.allStatus$.clearExplanationTxt();
  }

  fnClickElement(event: Event){
    event.stopPropagation();
    const targetElement: HTMLElement = event.target as HTMLElement;
    if(targetElement.tagName === 'EM'){
      this.allStatus$.setDisplayProgressSpinner(true);
      let txtForSearch = this.tooltipMessage;
      this.ai.getWikiInfo(txtForSearch).pipe(
        take(1),
        takeUntilDestroyed(this.destroyRef)
      ).subscribe({
        next:(result)=>{
          this.allStatus$.setDisplayProgressSpinner(false);
          if(result.success){ 
            const dialogConfig = new MatDialogConfig();
            dialogConfig.panelClass = 'nutri-templs';
            dialogConfig.backdropClass = 'nutri-templs-backdrop';
            dialogConfig.data = {
              text: result.data
            }
            const dialogRef = this.dialog.open(AiWindow, dialogConfig); 
          }else{
            
            this.notification.setMessage(result.message);
            this.notification.display();
            this.allStatus$.setDisplayProgressSpinner(false);
          }
        },
        error: (err: any)=>{
          
          this.notification.setMessage(err);
          this.notification.display();
          this.allStatus$.setDisplayProgressSpinner(false);
        }
    });
      
    }
  }

  collapseExpand(){
    this.isCollapseExpand.set(!this.isCollapseExpand());
  }

  isCardPlayer(typeId: number):boolean{
    let myCard: boolean = false;
    if(this.player.rq_id > 100){
      let id = this.player.rq_id - 100;
      if(id === typeId){
        myCard = true;
      }
    }
    return myCard;
  }
}
